<template>
  <div class="membership-apply-step mt-2">
    <b-row>
      <b-col cols="12" class="mb-3">
        <h5 class="mb-0 text-primary">Apply membership</h5>
        <small class="text-muted">
          Choose whether membership discounts apply to the total cost of this visit.
        </small>
      </b-col>
    </b-row>

    <!-- No membership -->
    <b-row v-if="!hasMembership" class="no-membership">
      <b-col cols="12">
        <b-alert variant="light" show class="d-flex align-items-center border rounded">
          <i class="fas fa-info-circle text-muted mr-2"></i>
          <span>The patient does not have an active membership for this visit. The total will be calculated without plan discounts.</span>
        </b-alert>
      </b-col>
    </b-row>

    <!-- With membership (type 1): toggle, summary and block "valores reducidos" -->
    <template v-else>
      <!-- Plan con valores reducidos: nuevo campo cuando membership_type === 1 -->
      <b-row v-if="isReducedMembershipType" class="mb-3">
        <b-col cols="12">
          <b-card no-body class="border rounded bg-light">
            <b-card-body class="py-3">
              <div class="d-flex align-items-center">
                <i class="fas fa-tag text-primary mr-2"></i>
                <div>
                  <span class="font-weight-bold text-dark">Plan con valores reducidos</span>
                  <small class="d-block text-muted">
                    Este plan aplica precios reducidos. En el siguiente paso (Charges and costs) verá el total con los descuentos aplicados.
                  </small>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" class="mb-3">
          <b-card no-body class="border shadow-sm rounded">
            <b-card-body class="py-3">
              <div class="d-flex flex-wrap align-items-center justify-content-between">
                <div class="mb-2 mb-md-0">
                  <span class="font-weight-bold text-dark">{{ membershipPlanName }}</span>
                  <small class="d-block text-muted">
                    Valid: {{ membership.start_date }} – {{ membership.end_date }}
                  </small>
                </div>
                <b-form-checkbox
                  v-model="applyMembershipLocal"
                  switch
                  size="lg"
                  class="mb-0"
                  @change="onToggle">
                  <span class="ml-2">{{ applyMembershipLocal ? 'Apply discounts' : 'Do not apply' }}</span>
                </b-form-checkbox>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-row v-if="applyMembershipLocal">
        <b-col cols="12">
          <p class="text-muted small mb-0">
            In the next step (Charges and costs), benefits that apply to the selected items (consultation, laboratories, procedures, tests, and treatments) will be automatically discounted according to the plan. You can view the detail there with the "See discounts" button.
          </p>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { BRow, BCol, BAlert, BCard, BCardBody, BFormCheckbox } from 'bootstrap-vue'

export default {
  name: 'MembershipApplyStep',
  components: {
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardBody,
    BFormCheckbox,
  },
  props: {
    /** Patient membership object (getDataOma) or null */
    membership: {
      type: Object,
      default: null,
    },
    /** Whether to apply discounts by default when membership exists */
    applyMembership: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      applyMembershipLocal: true,
    }
  },
  computed: {
    hasMembership() {
      return this.membership && this.membership.id && this.membership.memberships_parameters
    },
    membershipPlanName() {
      if (!this.hasMembership) return ''
      return this.membership.memberships_parameters.name || 'Plan'
    },
    /** True when membership_type === 1 (plan con valores reducidos). This step is only shown when type 1. */
    isReducedMembershipType() {
      if (!this.hasMembership) return false
      const type = this.membership.memberships_parameters.membership_type
      return Number(type) === 1
    },
  },
  watch: {
    applyMembership: {
      immediate: true,
      handler(val) {
        this.applyMembershipLocal = val
      },
    },
    membership: {
      immediate: true,
      handler(mem) {
        if (mem && mem.id) {
          this.applyMembershipLocal = this.applyMembership
        } else {
          this.applyMembershipLocal = false
        }
      },
    },
  },
  methods: {
    onToggle() {
      this.$emit('applyMembership', this.applyMembershipLocal)
    },
  },
}
</script>

<style lang="scss" scoped>
.membership-apply-step {
  .no-membership .alert {
    background-color: #f8f9fa;
  }
}
</style>
